export default [
  {
    label: 'bundles.position',
    field: 'templatePositionDescription',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    label: 'bundles.positionType',
    field: 'templatePositionTypeDescription',
    filterable: true,
    sortable: true,
    filterDropdown: true,
    filterOptions: [],
    placeholder: ' ',
  },
  {
    label: 'bundles.vasCode',
    field: 'vasList',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    label: 'bundles.vasCodeType',
    field: 'vasTypeDescription',
    filterable: true,
    sortable: true,
    filterDropdown: true,
    filterOptions: [],
    placeholder: ' ',
  },
  {
    label: 'bundles.lastConsumption',
    field: 'lastUsed',
    filterable: true,
    sortable: true,
    type: 'String',
    placeholder: ' ',
    width: '150px',
  },
  {
    label: 'bundles.startVolume',
    field: 'calcUniqueIncludedVolume' /* resellingIncludedVolume */,
    filterable: true,
    sortable: true,
    type: 'string',
    placeholder: ' ',
  },
  {
    label: 'bundles.remainingVolume',
    field: 'calcUniqueRemainingVolume',
    filterable: true,
    sortable: true,
    type: 'string',
    placeholder: ' ',
  },
  {
    label: 'bundles.toPay',
    field: 'calcUniqueRemainingToPayVolume' /* resellingInitToPayVolume */,
    filterable: true,
    sortable: true,
    type: 'number',
    placeholder: ' ',
  },
  {
    label: 'bundles.overallConsumption',
    field: 'calcUniqueConsumedVolume' /* resellingConsumedVolume  */,
    filterable: true,
    sortable: true,
    type: 'number',
    placeholder: ' ',
  },
];
